/* eslint-disable */
import init from 'baseapp/baseMain'
import App from './App'
import router from './router/router'
import store from './store/store'
import { MutationTypes } from './store/mutation-types'

init(store, router, MutationTypes.INIT_STORE)

/* eslint-disable no-new */
new window.Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  // render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/apps/buyerapp/main.js